module.exports = __webpack_public_path__ + "static/media/coppenrath-wiese-2x.329b9b11.jpg";